import * as React from "react";
import styled from "styled-components";

import { User } from "../entities";
import MembershipSectionCoverImage from "./MembershipSectionCoverImage";

interface Props {
  className?: string;
  members: User[];
}

const MembershipSectionCover: React.SFC<Props> = props => {
  const { members } = props;

  return (
    <div className={props.className}>
      {members.map((member, index) => (
        <MembershipSectionCoverImage
          key={member.id}
          avatar={member.avatar}
          index={index}
          allCountOfAvatars={members.length}
        />
      ))}
    </div>
  );
};

const StyledMembershipSectionCover = styled(MembershipSectionCover)`
  display: flex;
  flex-direction: ${props => (props.members.length === 2 || props.members.length === 3 ? "column" : "row")};
  flex-wrap: wrap;
  background: gray; // TODO
  width: 100%;
  height: 100%;
  filter: blur(0);
`;

export default StyledMembershipSectionCover;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipSectionCover.tsx